import * as React from "react";
import { Modal } from "../../../components/Modal/Modal";
import { TwoButtonDialog } from "../Dialogs/TwoButtonDialog";

interface Props
{
    isConfirmationDialogShown?: boolean;
    errorMessage?: string;

    title: string;
    okTitle: string;
    cancelTitle: string;
    ok: () => void;
    cancel: () => void;
}

export class Confirmation extends React.Component<Props, any>
{
    render()
    {
        const { isConfirmationDialogShown, errorMessage, children, ok, cancel, title, okTitle, cancelTitle, ...rest } = this.props;
        if(!isConfirmationDialogShown)
            return null;

        return (
            <Modal> 
                <TwoButtonDialog okTitle={okTitle} cancelTitle={cancelTitle} title={title} errorMessage={errorMessage} cancel={cancel} ok={ok}
                    {...rest}>
                    {children}
                </TwoButtonDialog>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Dialogs/Confirmation.tsx